import { render, staticRenderFns } from "./ModalCorrectInputEnglish.vue?vue&type=template&id=069dccd1&scoped=true&lang=pug&"
import script from "./ModalCorrectInputEnglish.vue?vue&type=script&lang=ts&"
export * from "./ModalCorrectInputEnglish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069dccd1",
  null
  
)

export default component.exports